import {
  analytics,
  cookieConsent,
  crashReporting,
  iovation,
  recaptcha,
} from "@jsainsburyplc/id-ui-common";
import { isIovationEnabled, isProd, isRecapchaEnabled } from "./env";

const NEW_RELIC_PROD_ID = "879190225";
const NEW_RELIC_NON_PROD_ID = "879562377";

// iovation proxy hook
const IOVATION_URI_HOOK = "/iojs";
// the sub-key is an optional parameter and is used for debugging purposes
const IOVATION_SUB_KEY = "";

export default (() => {
  const isProdEnv = isProd();
  const isIovationEnabledEnv = isIovationEnabled();
  const isRecapchaEnapledEnv = isRecapchaEnabled();
  const newRelicId = isProdEnv ? NEW_RELIC_PROD_ID : NEW_RELIC_NON_PROD_ID;

  // load analytics via Tealium and GA
  analytics(isProdEnv);

  // load cookie compliance policy via OneTrust
  cookieConsent(isProdEnv);

  // load crash reporting via New Relic
  crashReporting(newRelicId);

  // load Iovation scripts
  if (isIovationEnabledEnv) {
    iovation(IOVATION_URI_HOOK, IOVATION_SUB_KEY);
  }

  if (isRecapchaEnapledEnv) {
    recaptcha(process.env.REACT_APP_CAPTCHA_API_KEY_v3);
  }
})();
